import AnalyticsReportsAPI from '../../api/analyticsReports';

const state = {
  data: {
    agentMetrics: [],
    waitingConversations: [],
    waitingTotal: 0,
    waitingPage: 1,
    waitingTotalPages: 1,
    summary: {},
  },
  uiFlags: {
    isFetching: false,
  },
};

const getters = {
  getAnalyticsData: $state => $state.data,
  getAgentMetrics: $state => $state.data.agentMetrics,
  getWaitingConversations: $state => $state.data.waitingConversations,
  getWaitingTotal: $state => $state.data.waitingTotal,
  getWaitingPage: $state => $state.data.waitingPage,
  getWaitingTotalPages: $state => $state.data.waitingTotalPages,
  getSummary: $state => $state.data.summary,
  getUIFlags: $state => $state.uiFlags,
};

const mutations = {
  SET_ANALYTICS_DATA(st, data) {
    st.data = {
      agentMetrics: data.agent_metrics || [],
      waitingConversations: data.waiting_conversations || [],
      waitingTotal: data.waiting_total || 0,
      waitingPage: data.waiting_page || 1,
      waitingTotalPages: data.waiting_total_pages || 1,
      summary: data.summary || {},
    };
  },
  SET_FETCHING_STATUS(st, status) {
    st.uiFlags.isFetching = status;
  },
};

const actions = {
  async fetchAnalytics({ commit }, params) {
    commit('SET_FETCHING_STATUS', true);
    try {
      const { data } = await AnalyticsReportsAPI.getAnalytics(params);
      commit('SET_ANALYTICS_DATA', data);
    } catch (error) {
      // silently fail
    } finally {
      commit('SET_FETCHING_STATUS', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
